import React from 'react';
import styled from 'styled-components';

import { checkValidity } from '../util/checkValidity';
import { isYellow } from '../util/isYellow';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px;
  margin: 2px;
  border: 1px solid var(--border);
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

const Letter = styled.div<{ green?: boolean; yellow?: boolean; red?: boolean }>`
  display: flex;
  width: 20px;
  height: 20px;
  border: 1px solid var(--border-strong);
  border-radius: 5px;
  background-color: var(--tile-bg);
  color: var(--text);
  align-items: center;
  justify-content: center;

  ${({ yellow }) => yellow && 'background-color: var(--present); color: #111827;'}
  ${({ green }) => green && 'background-color: var(--correct); color: #111827;'}
  ${({ red }) => red && 'background-color: var(--invalid); color: #111827;'}
`;

function Puzzle({
  expired,
  wordle,
  working,
  guesslist,
}: {
  expired: boolean;
  wordle: string;
  working: string;
  guesslist: string[];
}) {
  return (
    <Container>
      {guesslist.map((guess, gnum) => (
        <Row key={guess}>
          {guess.split('').map((letter, i) => (
            <Letter
              green={letter === wordle[i]}
              key={`${letter}${i},${gnum}`}
              yellow={isYellow(wordle, guess, i)}
            >
              {letter}
            </Letter>
          ))}
        </Row>
      ))}
      {!expired && (
        <Row>
          {working.split('').map((letter, i) => (
            <Letter
              key={`${letter}${i}W`}
              red={working.length === 5 && !checkValidity(working)}
            >
              {letter}
            </Letter>
          ))}
          {working.length <= 5 &&
            Array.from(Array(5 - working.length)).map((e, i) => (
              <Letter key={`empty-${i}`}> </Letter>
            ))}
        </Row>
      )}
    </Container>
  );
}

export default Puzzle;
